import { useEffect, useMemo, useRef } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Chart from "chart.js/auto";
import Loading from "src/components/Loading";
import OwdEmplyeesTableSingle from "./OwdEmplyeesTableSingle";

export default function OwdEmployeesSingle({
  owdItems,
  setOwdItems,
  setExportData,
  loading,
  setQuery,
  query,
  cardVersion,
}: any) {
  useEffect(() => {
    return () => {
      setOwdItems([]);
    };
  }, []);

  const CircularChartUI = ({
    percentage = { uncompleted: 0, completed: 0, unstart: 0, cancelled: 0 },
  }: {
    percentage?: { uncompleted: number; completed: number; unstart: number; cancelled: number };
  }) => {
    const chartRef = useRef<HTMLCanvasElement | null>(null);
    const chartInstance = useRef<Chart | null>(null);

    useEffect(() => {
      const ctx = chartRef.current!.getContext("2d");
      const options = {
        maintainAspectRatio: false,
        responsive: true,
        cutout: "70%", // Размер внутреннего радиуса (создание толщины кольца)
        rotation: 0, // Поворот на 90 градусов, чтобы заполнение шло сверху
        circumference: 360, // Полный круг
        animation: {
          animateRotate: true,
          duration: 1000,
        },
        plugins: {
          tooltip: {
            enabled: false, // Отключить тултипы
          },
          legend: {
            display: false, // Скрыть легенду
          },
          datalabels: {
            display: false,
          },
        },
      };

      if (!chartInstance.current) {
        chartInstance.current = new Chart(ctx!, {
          type: "doughnut",
          data: {
            labels: [],
            datasets: [{
              data: [percentage.completed, percentage.uncompleted, percentage.unstart, percentage.cancelled],
              backgroundColor: ["#5475E5", "#ADBCF2", "#E1E8FF", "#18BFFF"],
              borderWidth: 0
            }]
          },
          options
        });
      } else {
        chartInstance.current.data.datasets[0].data = [
          percentage.completed, percentage.uncompleted, percentage.unstart, percentage.cancelled
        ];
        chartInstance.current.update();
      }
    }, [percentage]);

    useEffect(() => {
      return () => {
        chartInstance.current?.destroy();
      };
    }, []);

    return (
      <div className="max-w-[108px] max-h-[108px] rotate-45">
        <canvas ref={chartRef} />
      </div>
    );
  };
  const CircularChart = ({
    countOfOwd,
  }: {
    countOfOwd: { completed: number; uncompleted: number; unstart: number; cancelled: number };
  }) => {

    const percentage = useMemo(() => {
      return countOfOwd;
    }, [countOfOwd]);

    return <CircularChartUI percentage={percentage} />;
  };

  return (
    <>
      <FlexRow className="px-7.5 py-7.5 justify-center space-x-[15px] shadow-custom bg-white w-full rounded">
        <FlexCol className="items-center justify-center">
          {(!loading && (
            <CircularChart
              countOfOwd={{
                completed: Math.round(
                  (owdItems.filter((item: any) => item.isPass).length /
                    owdItems.length) *
                  100
                ),
                uncompleted: Math.round(
                  (owdItems.filter(
                    (item: any) => !item.isPass && item.TestAnswerRate > 0
                  ).length /
                    owdItems.length) *
                  100
                ),
                unstart: Math.round(
                  (owdItems.filter(
                    (item: any) => !item.isPass && item.TestAnswerRate === 0
                  ).length /
                    owdItems.length) *
                  100
                ),
                cancelled: Math.round(
                  (owdItems.filter((item: any) => item.Title.includes("Отклонено")).length / owdItems.length) * 100
                ) || 0
              }}
            />
          )) || (
              <FlexCol className="mr-5">
                <Loading />
              </FlexCol>
            )}
        </FlexCol>
        <FlexCol>
          <div>
            <h5 className="font-medium text-black">Уровень проведения OWD</h5>
            <div className="flex items-center mt-2.5">
              <span className="block w-1 h-4 mr-2 bg-[#5475E5] rounded-full"></span>
              <p>
                {(owdItems.filter((item: any) => item.isPass).length > 0 &&
                  Math.round(
                    (owdItems.filter((item: any) => item.isPass).length /
                      owdItems.length) *
                    100
                  )) ||
                  "0"}
                % ({owdItems.filter((item: any) => item.isPass).length}) сданных
                owd
              </p>
            </div>
            <div className="flex items-center mt-1">
              <span className="block w-1 h-4 mr-2 bg-[#ADBCF2] rounded-full"></span>
              <p>
                {(owdItems.filter(
                  (item: any) => !item.isPass && item.TestAnswerRate > 0
                ).length > 0 &&
                  Math.round(
                    (owdItems.filter(
                      (item: any) => !item.isPass && item.TestAnswerRate > 0
                    ).length /
                      owdItems.length) *
                    100
                  )) ||
                  "0"}
                % (
                {
                  owdItems.filter(
                    (item: any) => !item.isPass && item.TestAnswerRate > 0
                  ).length
                }
                ) несданных owd
              </p>
            </div>
            <div className="flex items-center mt-1">
              <span className="block w-1 h-4 mr-2 bg-[#E1E8FF] rounded-full"></span>
              <p>
                {(owdItems.filter(
                  (item: any) => !item.isPass && item.TestAnswerRate === 0
                ).length > 0 &&
                  Math.round(
                    (owdItems.filter(
                      (item: any) => !item.isPass && item.TestAnswerRate === 0
                    ).length /
                      owdItems.length) *
                    100
                  )) ||
                  "0"}
                % (
                {
                  owdItems.filter(
                    (item: any) => !item.isPass && item.TestAnswerRate === 0
                  ).length
                }
                ) непроведенных owd
              </p>
            </div>
            <div className="flex items-center mt-1">
              <span className="block w-1 h-4 mr-2 bg-[#18BFFF] rounded-full"></span>
              <p>
                {(owdItems.filter((item: any) => item.Title.includes("Отклонено")).length > 0 &&
                  Math.round(
                    (owdItems.filter((item: any) => item.Title.includes("Отклонено")).length / owdItems.length) * 100
                  )) ||
                  "0"}
                % ({owdItems.filter((item: any) => item.Title.includes("Отклонено")).length}) отклоненных owd
              </p>
            </div>
          </div>
        </FlexCol>
      </FlexRow>
      <OwdEmplyeesTableSingle
        setExportData={setExportData}
        data={owdItems}
        cardVersion={cardVersion}
        setQuery={setQuery}
        query={query}
      />
    </>
  );
}
